<div class="modal-wrapper">
  <app-base-modal dialogTitle="Choose a step to add" (closeEvent)="onCancel()">
    <div class="table-steps">
      <table mat-table [dataSource]="data.rimsStepInfos">
        <!-- Radio Button -->
        <ng-container matColumnDef="selectRadio">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <mat-radio-group [(ngModel)]="selectedRimsStepInfo">
              <mat-radio-button [value]="row"></mat-radio-button>
            </mat-radio-group>
          </td>
        </ng-container>

        <!-- Step Id -->
        <ng-container matColumnDef="stepId">
          <th mat-header-cell *matHeaderCellDef>Step Id</th>
          <td mat-cell *matCellDef="let element">{{ element.stepId }}</td>
        </ng-container>

        <!-- Name -->
        <ng-container matColumnDef="stepName">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.stepName }}</td>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element">{{ element.description }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="rimsStepsGridColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: rimsStepsGridColumns"></tr>
      </table>

      @if (data.rimsStepInfos.length === 0) {
        <h5 class="no-steps-header">There are no more steps available</h5>
      }
    </div>
    <br />
    <!-- This is projected by the ng-content of the app-base-modal -->
    <div panel-footer>
      <button mat-flat-button class="button-link" (click)="onCancel()">Cancel</button>
      <button mat-flat-button class="button-primary" (click)="onAdd()" [disabled]="!selectedRimsStepInfo">Add</button>
    </div>
  </app-base-modal>
</div>
